import EA from '../helpers/init';
import { createApp } from 'vue';

export default EA.Methods.exampleMethod = ($this) => {
    console.log('exampleMethod', $this);
};
